
import { Message } from 'element-ui';

// const toast = {
//     fail(text){
//         Toast.fail(text);
//     },
//     success(text){
//         Toast.success(text);
//     },
//     loading(text = '加载中...'){
//         Toast.loading({
//             mask: true,
//             message: text
//         });
//     }
// }

// export { toast };

export default {
    message(text){
        Message.closeAll();
        Message({
            showClose: true,
            message: text,
            type: 'success'
        });
    },

    error(text){
        Message.closeAll();
        Message({
            showClose: true,
            message: text,
            type: 'error'
        });
    },

}